import { ChangeDetectionStrategy, Component, computed, input, InputSignal, model, ModelSignal, Signal } from '@angular/core';
import { FilterChipModel } from '@libs/common/components';
import { ChipFilterGroupComponent } from '@libs/form/components';
import { ProductListItemBaseModel, TopLevelCategoryNode } from '@libs/shop/models';

@Component({
  selector: 'ui-product-categories-filter',
  templateUrl: './product-categories-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ChipFilterGroupComponent],
})
export class ProductCategoriesFilterComponent {
  public nodes: InputSignal<TopLevelCategoryNode<ProductListItemBaseModel>[]> = input.required();
  public selectedNodes: ModelSignal<TopLevelCategoryNode<ProductListItemBaseModel>[]> = model([] as TopLevelCategoryNode<ProductListItemBaseModel>[]);

  public filterChips: Signal<FilterChipModel[]> = computed(() => this.buildFilterChips());
  public totalItemsCount: Signal<number> = computed(() => this.getTotalCount());

  public selectedChips: Signal<FilterChipModel[]> = computed(() => this.getSelectedChips());

  private readonly selectedNodeIds: Signal<string[]> = computed(() => this.selectedNodes().map(x => x.id));

  public selectedChanged(selected: FilterChipModel[]): void {
    const selectedIds: string[] = selected.map(x => x.id.toString());
    const selectedNodes: TopLevelCategoryNode<ProductListItemBaseModel>[] = this.nodes().filter(x => selectedIds.includes(x.id.toString()));

    this.selectedNodes.set(selectedNodes);
  }

  private getSelectedChips(): FilterChipModel[] {
    if (!this.selectedNodes()) {
      return [];
    }

    return this.filterChips().filter((x) => this.selectedNodeIds().includes(x.id.toString()));
  }

  private buildFilterChips(): FilterChipModel[] {
    return this.nodes().map((node) => ({
      id: node.id,
      title: node.label,
      count: node.count,
    }));
  }

  private getTotalCount(): number {
    return this.nodes().reduce((sum, node) => sum + node.count, 0);
  }
}
